import { render } from "./ContactQuickCreate.vue?vue&type=template&id=364c87ee"
import script from "./ContactQuickCreate.vue?vue&type=script&lang=ts"
export * from "./ContactQuickCreate.vue?vue&type=script&lang=ts"
script.render = render

export default script